/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as NativeRedirectRouteImport } from './routes/native-redirect'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SsoIndexRouteImport } from './routes/sso/index'
import { Route as MfaPromptIndexRouteImport } from './routes/mfa-prompt/index'
import { Route as SsoCallbackRouteImport } from './routes/sso/callback'
import { Route as SsoTenantRouteImport } from './routes/sso/$tenant'
import { Route as SignOutCallbackRouteImport } from './routes/sign-out/callback'
import { Route as SignInCallbackRouteImport } from './routes/sign-in/callback'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const NativeRedirectRoute = NativeRedirectRouteImport.update({
  id: '/native-redirect',
  path: '/native-redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoIndexRoute = SsoIndexRouteImport.update({
  id: '/sso/',
  path: '/sso/',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaPromptIndexRoute = MfaPromptIndexRouteImport.update({
  id: '/mfa-prompt/',
  path: '/mfa-prompt/',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso/callback',
  path: '/sso/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoTenantRoute = SsoTenantRouteImport.update({
  id: '/sso/$tenant',
  path: '/sso/$tenant',
  getParentRoute: () => rootRouteImport,
} as any)
const SignOutCallbackRoute = SignOutCallbackRouteImport.update({
  id: '/sign-out/callback',
  path: '/sign-out/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInCallbackRoute = SignInCallbackRouteImport.update({
  id: '/sign-in/callback',
  path: '/sign-in/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/native-redirect': typeof NativeRedirectRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in/callback': typeof SignInCallbackRoute
  '/sign-out/callback': typeof SignOutCallbackRoute
  '/sso/$tenant': typeof SsoTenantRoute
  '/sso/callback': typeof SsoCallbackRoute
  '/mfa-prompt': typeof MfaPromptIndexRoute
  '/sso': typeof SsoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/native-redirect': typeof NativeRedirectRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in/callback': typeof SignInCallbackRoute
  '/sign-out/callback': typeof SignOutCallbackRoute
  '/sso/$tenant': typeof SsoTenantRoute
  '/sso/callback': typeof SsoCallbackRoute
  '/mfa-prompt': typeof MfaPromptIndexRoute
  '/sso': typeof SsoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/native-redirect': typeof NativeRedirectRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in/callback': typeof SignInCallbackRoute
  '/sign-out/callback': typeof SignOutCallbackRoute
  '/sso/$tenant': typeof SsoTenantRoute
  '/sso/callback': typeof SsoCallbackRoute
  '/mfa-prompt/': typeof MfaPromptIndexRoute
  '/sso/': typeof SsoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/native-redirect'
    | '/reset-password'
    | '/sign-in/callback'
    | '/sign-out/callback'
    | '/sso/$tenant'
    | '/sso/callback'
    | '/mfa-prompt'
    | '/sso'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/native-redirect'
    | '/reset-password'
    | '/sign-in/callback'
    | '/sign-out/callback'
    | '/sso/$tenant'
    | '/sso/callback'
    | '/mfa-prompt'
    | '/sso'
  id:
    | '__root__'
    | '/'
    | '/native-redirect'
    | '/reset-password'
    | '/sign-in/callback'
    | '/sign-out/callback'
    | '/sso/$tenant'
    | '/sso/callback'
    | '/mfa-prompt/'
    | '/sso/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  NativeRedirectRoute: typeof NativeRedirectRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInCallbackRoute: typeof SignInCallbackRoute
  SignOutCallbackRoute: typeof SignOutCallbackRoute
  SsoTenantRoute: typeof SsoTenantRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
  MfaPromptIndexRoute: typeof MfaPromptIndexRoute
  SsoIndexRoute: typeof SsoIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/native-redirect': {
      id: '/native-redirect'
      path: '/native-redirect'
      fullPath: '/native-redirect'
      preLoaderRoute: typeof NativeRedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso/': {
      id: '/sso/'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof SsoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa-prompt/': {
      id: '/mfa-prompt/'
      path: '/mfa-prompt'
      fullPath: '/mfa-prompt'
      preLoaderRoute: typeof MfaPromptIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso/callback': {
      id: '/sso/callback'
      path: '/sso/callback'
      fullPath: '/sso/callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso/$tenant': {
      id: '/sso/$tenant'
      path: '/sso/$tenant'
      fullPath: '/sso/$tenant'
      preLoaderRoute: typeof SsoTenantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-out/callback': {
      id: '/sign-out/callback'
      path: '/sign-out/callback'
      fullPath: '/sign-out/callback'
      preLoaderRoute: typeof SignOutCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/callback': {
      id: '/sign-in/callback'
      path: '/sign-in/callback'
      fullPath: '/sign-in/callback'
      preLoaderRoute: typeof SignInCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  NativeRedirectRoute: NativeRedirectRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInCallbackRoute: SignInCallbackRoute,
  SignOutCallbackRoute: SignOutCallbackRoute,
  SsoTenantRoute: SsoTenantRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  MfaPromptIndexRoute: MfaPromptIndexRoute,
  SsoIndexRoute: SsoIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
